module.exports = __webpack_public_path__ + "img/grow_grow2.ed6cb209.svg";